import { useWidget } from '@telescope/cassini-hooks';
import { Box, Flex, VStack } from '@telescope/cassini-ui';
import { FallbackError } from 'components';
import { Header, Footer } from 'features';
import { useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router-dom';
import { isIframed, loadWidgetFonts } from 'utils';
import { APP_MAX_WIDTH } from 'utils/style-variables';
import { GeoBlocking } from 'features';
import { TopContent } from './TopContent';
import { BottomContent } from './BottomContent';
import { Open, Closed } from 'generated-types/widget';
import { AuthProvider } from 'features';

const isAppIframed = isIframed();

export const AppShell = () => {
  const { data } = useWidget({ select: (data: Open | Closed) => data.widget });
  const { fonts: accountFonts, global_views, campaignFonts: { fonts: { font_settings } } } = data!;
  const fontSettings = font_settings as any;
  const { sitewide } = global_views;

  useEffect(() => {
    loadWidgetFonts([ ...accountFonts, ...fontSettings ]);
  }, [accountFonts, fontSettings]);

  return (
    <VStack as={Flex} direction="column" minH={isAppIframed ? 'auto' : '100vh'} alignItems="center" spacing={8} {...sitewide.styles.app}>
      <GeoBlocking>

      <Header />

      <AuthProvider>
        <TopContent />
        <Flex as="main" flex={isAppIframed ? 0 : 1} overflowX="hidden" 
              flexGrow="2" py={[ 2, 8 ]} w="100%" maxW={{ base: APP_MAX_WIDTH.MOBILE, md: APP_MAX_WIDTH.TABLET, lg: APP_MAX_WIDTH.DESKTOP }}>
          <ErrorBoundary FallbackComponent={FallbackError}>
            <Outlet />
          </ErrorBoundary>
        </Flex>
        <BottomContent />
      </AuthProvider>

      <Footer />

      </GeoBlocking>
    </VStack>
  );
};
